<template>
  <div data-qa="transferfundsintrabankpayeelist-div-lwg2nb">
    <v-list-item two-line  data-qa="transferfundsintrabankpayeelist-list-item-jeun1e">
      <v-list-item-content data-qa="transferfundsintrabankpayeelist-list-item-content-8eude">
        <v-list-item-title data-qa="transferfundsintrabankpayeelist-list-item-title-bk6num">
          <v-text-field data-qa="transferfundsintrabankpayeelist-text-field-nff7ie"
            v-model="search"
            :label="$t('transferfunds.payeeSearchLabel')"
            :color="primaryColor"
            prepend-inner-icon="mdi-magnify"
            class="transferFunds--custom-textfield"
            clearable
            filled
          />
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list two-line flat class="mt-n8"  data-qa="transferfundsintrabankpayeelist-list-937egr">
      <v-row v-if="isAddPayeePermitted.sameBank" no-gutters justify="end" class="px-3" data-qa="transferfundsintrabankpayeelist-row-ys6mft">
        <v-btn data-qa="transferfundsintrabankpayeelist-btn-79a38"
          @click="$emit('open-add-new-payee')"
          :color="primaryColor"
          dark
          class="text-capitalize py-2 px-4"
          v-text="$t('transferfunds.addPayeeBtn')"
        />
      </v-row>
      <v-list-item
        v-for="(item, i) in payeeSearchFilter"
        :key="item.beneficiaryId"
        @click="$emit('payee-selected', item)"
        :data-qa="`transferfundsintrabankpayeelist-list-item-2j8v0-${i}`"
      >
        <v-list-item-content :data-qa="`transferfundsintrabankpayeelist-list-item-content-dcvs8b-${i}`">
          <v-list-item-title :data-qa="`transferfundsintrabankpayeelist-list-item-title-rjsni4-${i}`"
            v-text="item.beneficiaryReference"
            class="text--primary"
          />
          <v-list-item-subtitle :data-qa="`transferfundsintrabankpayeelist-list-item-subtitle-k0iaj-${i}`"  v-text="item.beneficiaryAccount" />
          <v-divider :data-qa="`transferfundsintrabankpayeelist-divider-6wcga-${i}`"  class="mt-2"/>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-row v-if="!payeeSearchFilter.length" no-gutters justify="center" class="pa-2" data-qa="transferfundsintrabankpayeelist-row-djuiy">
      {{ $t('payee.notAvailable')}}
    </v-row>
  </div>
</template>

<script>
import store from '@/core/store'
import '@/styles/pages/transferFunds.scss'
export default {
  name: 'TransferFundsIntrabankPayeeList',
  props: {
    beneficiaryList: Array
  },
  data () {
    return {
      search: '',
      isAddPayeePermitted: {
        sameBank: false
      }
    }
  },
  computed: {
    payeeSearchFilter () {
      if (!this.beneficiaryList.length) return []
      if (!this.search) return this.beneficiaryList
      const searchLC = this.search.toLowerCase()
      return this.beneficiaryList.filter(item =>
        item.beneficiaryReference.toLowerCase().includes(searchLC) ||
        item.beneficiaryAccount.toLowerCase().includes(searchLC)
      )
    }
  },
  created () {
    let isSmeLogin = JSON.parse(sessionStorage.getItem('isSmeLogin'))
    let enableRoleBasedAccess = this.$appSettings.defaultConfigurations.smeRoles.enableRoleBasedAccess
    let permissions = store.getters['profileStore/profileData']?.permissions
    this.isAddPayeePermitted.sameBank = (isSmeLogin && enableRoleBasedAccess) ? permissions?.includes('ADD_AND_DELETE_SAME_BANK_PAYEES') : true
  }
}
</script>
